import { DatePipe } from '@angular/common';
import { Component, computed, input, OnInit, output } from '@angular/core';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { NoteService } from '@maximizer/outlook/note/data-access';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import {
  NoteSummary,
  OutlookAbEntryDetails,
  OutlookLeadSearch,
} from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'maximizer-summary-note',
  templateUrl: './summary-note.component.html',
  imports: [DatePipe, OUTLOOK_SHARED_UI, TranslatePipe, UI_PIPES],
})
export class SummaryNoteComponent implements OnInit {
  lead = input<OutlookLeadSearch>();
  abentry = input<OutlookAbEntryDetails>();
  deepLink = input<string>();
  id = input<string>('');

  loadErrorEvent = output<string>();
  loadingEvent = output<boolean>();

  loading = true;
  offsetDisplayedNote = 1;
  configuration: NoteSummary = {
    noteAmount: 0,
  };

  additionalNotes = computed(() => {
    return this.configuration.noteAmount > this.offsetDisplayedNote
      ? this.configuration.noteAmount - this.offsetDisplayedNote
      : 0;
  });

  constructor(
    private readonly noteService: NoteService,
    readonly outlookStore: OutlookStore,
  ) {}

  ngOnInit(): void {
    this.noteService
      .getSummary(this.id())
      .pipe(
        catchError(() => {
          this.loadErrorEvent.emit('note');
          return of(null);
        }),
        finalize(() => {
          this.loadingEvent.emit(false);
          this.loading = false;
        }),
      )
      .subscribe((data) => {
        if (!data) return;
        this.configuration = data;
      });
  }
}
